import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, Injector, NgModule, reflectComponentType, inject, provideAppInitializer } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { CookieNotificationComponent } from '@shared-components/cookie-notification/cookie-notification.component';
import { DropdownTogglerComponent } from '@shared-components/dropdown-toggler/dropdown-toggler.component';
import { NavbarTogglerComponent } from '@shared-components/navbar-toggler/navbar-toggler.component';
import { TestSystemNotificationComponent } from '@shared-components/test-system-notification/test-system-notification.component';
import { GenericErrorHandler } from '@shared-helpers/genericErrorHandler';
import { SubscriptionTracker } from '@shared-helpers/subscriptionTracker';
import { InitialiseService } from '@shared-services/initialise.service';

const components: any[] = [
  CookieNotificationComponent,
  TestSystemNotificationComponent,
  NavbarTogglerComponent,
  DropdownTogglerComponent,
];

@NgModule({
  //declarations: components,
  imports: [
    BrowserModule,
    components
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: GenericErrorHandler },
    { provide: SubscriptionTracker, useClass: SubscriptionTracker },
    provideAppInitializer(() => {
        const initializerFn = ((initialiseService: InitialiseService) => { return () => initialiseService.initialise(); })(inject(InitialiseService));
        return initializerFn();
      })
  ]
})
export class FourdModule {
  constructor(private injector: Injector) { }
  ngDoBootstrap() {
    for (const component of components) {
      const metadata = reflectComponentType(component);
      const htmlElement = createCustomElement(component, { injector: this.injector });
      customElements.define(metadata.selector, htmlElement);
    }
  }
}
